const initReviewApp = () => {
	if (!window.location.hostname.startsWith('review-feature')) return;

	const script = document.createElement('script');
	script.setAttribute('data-project-id', import.meta.env.VITE_CI_PROJECT_ID);
	script.setAttribute('data-project-path', import.meta.env.VITE_CI_PROJECT_PATH);
	script.setAttribute('data-merge-request-id', import.meta.env.VITE_CI_MERGE_REQUEST_IID);
	script.setAttribute('data-mr-url', 'https://git.inflcr.com');
	script.setAttribute('data-require-auth', 'true');
	script.id = 'review-app-toolbar-script';
	script.src = 'https://gitlab.com/assets/webpack/visual_review_toolbar.js';

	document.head.appendChild(script);
};

export { initReviewApp };
